var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocationDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.66667,
    fill: "#D1D8E8",
    stroke: "#848484",
    strokeWidth: 0.666667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.99935,
    cy: 4.99984,
    r: 2.33333,
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationDot);
export default __webpack_public_path__ + "static/media/currentLocationDot.7abca9ece220c66fd73ea8021b35c58c.svg";
export { ForwardRef as ReactComponent };